import { render, staticRenderFns } from "./BmCatalogoDetalles.vue?vue&type=template&id=0bc7cdc9&"
import script from "./BmCatalogoDetalles.vue?vue&type=script&lang=js&"
export * from "./BmCatalogoDetalles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports